const menu = {
  cah: [
    {
      path: "/",
      tag: "Inicio",
      name: "home"
    },
    {
      tag: "Acerca de",
      path: "/acerca-de"
      /*
      children: [
        {
          tag: "Subprogramas",
          direction: "right",
          children: [
            {
              path: "/subprogramas/oscilacion-sur",
              tag: "El Niño - Oscilación del Sur (ENSO)",
              name: "subp1"
            },
            {
              path: "/subprogramas/variabilidad-cambio-climatico",
              tag: "Variabilidad y Cambio Climático en el Perú",
              name: "subp2"
            },
            {
              path: "/subprogramas/eventos-meteorologicos-hidroclimaticos",
              tag: "Eventos meteorológicos e hidroclimáticos extremos",
              name: "subp3"
            }
          ]
        },
        {
          path: "/equipo",
          tag: "Nuestro Equipo",
          name: "our-team"
        }
      ]
      */
    },
    {
      tag: "Subprogramas",
      children: [
        {
          path: "/subprogramas/oscilacion-sur",
          tag: "El Niño - Oscilación del Sur (ENSO)",
          name: "subp1"
        },
        {
          path: "/subprogramas/variabilidad-cambio-climatico",
          tag: "Variabilidad y Cambio Climático en el Perú",
          name: "subp2"
        },
        {
          path: "/subprogramas/eventos-meteorologicos-hidroclimaticos",
          tag: "Eventos meteorológicos e hidroclimáticos extremos",
          name: "subp3"
        }
      ]
    },
    /*
    {
      tag: "Monitoreo y Pronóstico",
      path: "/monitoreo-pronostico/",
      children: [
        {
          path: "/monitoreo-pronostico/atmosfera",
          tag: "En Atmósfera",
          name: "mon1"
        },
        {
          path: "/monitoreo-pronostico/hidrosfera",
          tag: "En Hidrósfera",
          name: "mon2"
        }
      ]
    },
    */
    {
      tag: "Proyectos",
      path: "/proyectos/investigacion"
      //path: "http://met.igp.gob.pe/"
    },
    /*
    {
      tag: "Proyectos",
      children: [
        {
          path: "/proyectos/investigacion",
          tag: "Proyectos de Investigación",
          name: "project1"
        },
        {
          path: "/proyectos/tecnologico",
          tag: "Proyectos de Desarrollo Tecnológico",
          name: "project2"
        }
      ]
    },
    */
    {
      tag: "Facilidades",
      children: [
        {
          path: "/facilidad/dinamica",
          tag: "Dinámica de Fluídos Geofísicos",
          name: "mon1"
        },
        {
          path: "/facilidad/microfisica",
          tag: "Microfísica Atmosférica y Radiación",
          name: "mon2"
        }
      ]
    },
    {
      tag: "Publicaciones",
      children: [
        {
          path: "/publicaciones/articulos/arbitrados",
          tag: "Artículos Arbitrados"
        },
        {
          path: "/publicaciones/boletines",
          tag: "Boletines",
          children: [
            {
              path: "/publicaciones/boletines/el-nino",
              tag: "El Niño",
              name: "news3"
            },
            {
              path: "/publicaciones/boletines/incendios-forestales",
              tag: "Prevención de Incendios Forestales",
              name: "news1"
            },
            {
              path: "/publicaciones/boletines/valle-mantaro",
              tag: "Valle de Mantaro",
              name: "news2"
            }
          ]
        },
        {
          path: "/publicaciones/articulos/divulgacion",
          tag: "Artículos de Divulgación"
        },
        {
          path: "/publicaciones/articulos/avances",
          tag: "Artículos de Avances de Investigación"
        },
        {
          path: "/publicaciones/informes/tecnicos",
          tag: "Informes Técnicos"
        },
        {
          path: "/publicaciones/academicos/tesis",
          tag: "Tesis"
        }
      ]
    }
    /*
    {
      path: "/publicaciones",
      tag: "Divulgación",
      name: "publications",
      children: [
        {
          path: "/boletines/incendios-forestales",
          tag: "Charlas",
          name: "news1"
        },
        {
          path: "/boletines/valle-mantaro",
          tag: "Talleres",
          name: "news2"
        },
        {
          path: "/boletines/el-nino",
          tag: "Notas de Prensa",
          name: "news3"
        }
      ]
    }
    */
  ],
  cts: [
    {
      path: "/",
      tag: "Inicio",
      name: "home"
    },
    {
      path: "/acerca-de",
      tag: "Acerca de",
      name: "about"
    },
    {
      tag: "Subprogramas",
      children: [
        {
          path: "/subprogramas/procesos-dinamica-interna",
          tag: "Procesos de Dinámica Interna",
          name: "subp1"
        },
        {
          path: "/subprogramas/procesos-fisicos-suelos",
          tag: "Procesos Físicos de los Suelos",
          name: "subp2"
        }
      ]
    },
    {
      tag: "Proyectos",
      children: [
        {
          path: "/proyectos/investigacion",
          tag: "Proyectos de Investigación",
          name: "project1"
        },
        {
          path: "/proyectos/ppr",
          tag: "Proyectos de Presupuesto por Resultados",
          name: "PPRProjects"
        }
      ]
    },
    {
      path: "https://repositorio.igp.gob.pe/handle/20.500.12816/58",
      tag: "Publicaciones",
      name: "publications"
    },
    {
      path: "/glosario",
      tag: "Glosario",
      name: "glosary"
    }
  ],
  cga: [
    {
      path: "/",
      tag: "Inicio",
      name: "home"
    },
    {
      path: "/acerca-de",
      tag: "Acerca de",
      name: "about"
    },
    {
      tag: "Subprogramas",
      children: [
        {
          path: "/subprogramas/aeronomia-clima-espacial",
          tag: "Aeronomía y Clima Espacial",
          name: "subp1"
        },
        {
          path: "/subprogramas/meteoros-objetos-espaciales",
          tag: "Meteoros y Objetos Espaciales",
          name: "subp2"
        },
        {
          path: "/subprogramas/astronomia",
          tag: "Astronomía",
          name: "subp3"
        }
      ]
    },
    {
      tag: "Proyectos",
      children: [
        {
          path: "/proyectos/investigacion",
          tag: "Proyectos de Investigación",
          name: "project1"
        },
        {
          path: "/proyectos/tecnologico",
          tag: "Proyectos de Desarrollo Tecnológico",
          name: "project2"
        }
      ]
    },
    {
      path: "/publicaciones",
      tag: "Publicaciones",
      name: "publications"
    },
    {
      path: "/glosario",
      tag: "Glosario",
      name: "glosary"
    }
  ]
};
const trail = [
  {
    path: "https://www.gob.pe/igp",
    tag: "Portal IGP",
    name: "portal"
  },
  {
    path: "/",
    tag: process.env.VUE_APP_TITLE,
    name: "root"
  }
];
const dynamicTrail = [
  {
    tag: "Subprogramas",
    path: "/subprogramas"
  },
  {
    tag: "Proyectos",
    path: "/proyectos"
  }
];
function getMenu(program) {
  return menu[program] || "cts";
}
function getTrail() {
  return trail;
}
function getDynamicTrail() {
  return dynamicTrail;
}
export { getMenu, getTrail, getDynamicTrail };
